import { isEmpty } from "./strings.pipe";

export function snipUUID(id: string, len: number = 8): string {
	if( isEmpty(id) ) return '';
	if( id.includes('not') ) return id;
	return id.substring(0, len) + '...';
}

